import Vue from 'vue'
import Router from 'vue-router'
import firebase from 'firebase'

import Login from '../components/Login'
import Users from '../components/Users'
import News from '../components/News'
import Comments from '../components/Comments'
import Shops from '../components/Shops'
import NotFound from '../components/NotFound'

Vue.use(Router)

let router = new Router({
  routes: [
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/users',
      name: 'Users',
      component: Users,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/news',
      name: 'News',
      component: News,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/comments',
      name: 'Comments',
      component: Comments,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/shops',
      name: 'Shops',
      component: Shops,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '*',
      name: 'NotFound',
      component: NotFound
    }
  ]
})

router.beforeEach((to, from, next) => {
  let currentUser = firebase.auth().currentUser
  let requiresAuth = to.matched.some(record => record.meta.requiresAuth)

  if (requiresAuth && !currentUser) next('login')
  else if (!requiresAuth && currentUser) next('users')
  else next()
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js